import { store } from "../App"
import printJS from 'print-js'


export const stringOptions = [
    { code: 'Contains', label: 'Contains' },
    { code: 'StartsWith', label: 'Starts With' },
    { code: 'EndsWith', label: 'Ends With' },
    { code: 'Equals', label: 'Equals' },
    { code: 'GreaterThan', label: 'Greater Than' },
    { code: 'GreaterThanOrEqual', label: 'Greater Than Or Equal' },
    { code: 'LessThan', label: 'Less Than' },
    { code: 'LessThanOrEqual', label: 'Less Than Or Equal' },
    { code: 'NotEqual', label: 'Not Equal' },
]

export const booleanOptions = [
    { code: 'Equals', label: 'Equals' }
]

export const intOptions = [
    { code: 'less than' },
    { code: 'less than or equal to' },
    { code: 'equal to' },
    { code: 'greater than' },
    { code: 'greater than or equal to' }
]

export const dateOptions = [
    { code: 'Equals', label: 'Equals' },
    { code: 'GreaterThan', label: 'Greater Than' },
    // { code: 'GreaterThanOrEqual', label: 'Greater Than Or Equal' },
    { code: 'LessThan', label: 'Less Than' },
    { code: 'LessThanOrEqual', label: 'Less Than Or Equal' },
    { code: 'GreaterThanOrEqual', label: 'Between' },
]

export const searchColumns = [
    { data: "TrackingReferenceNumber", name: "Tracking Reference Number", search: { value: "", operatorValue: ""} },
    { data: "Institution.Name", name: "Institution Name", search: { value: "", operatorValue: ""} },
    { data: "BranchName", name: "Branch Name", search: { value: "", operatorValue: ""} },
    { data: "NameOfConsultant", name: "Name Of Consultant", search: { value: "", operatorValue: ""} },
    { data: "ClientTypeName", name: "Client Type Name", search: { value: "", operatorValue: ""} },
    { data: "NameOfComplainant", name: "Name Of Complainant", search: { value: "", operatorValue: ""} },
    { data: "FirstName", name: "First Name", search: { value: "", operatorValue: ""} },
    { data: "MiddleName", name: "Middle Name", search: { value: "", operatorValue: ""} },
    { data: "LastName", name: "Last Name", search: { value: "", operatorValue: ""} },
    { data: "UniqueIdentificationNo", name: "Unique Identification No", search: { value: "", operatorValue: ""} },
    { data: "AccountNumber", name: "Account Number", search: { value: "", operatorValue: "", type: 'number'} },
    { data: "AccountTypeName", name: "Account Type Name", search: { value: "", operatorValue: ""} },
    { data: "CurrencyCode", name: "Currency Code", search: { value: "", operatorValue: ""} },
    { data: "StreetAddressLine1", name: "Street Address Line 1", search: { value: "", operatorValue: ""} },
    { data: "StreetAddressLine2", name: "Street Address Line 2", search: { value: "", operatorValue: ""} },
    { data: "City", name: "City", search: { value: "", operatorValue: ""} },
    { data: "State", name: "State", search: { value: "", operatorValue: ""} },
    { data: "Country", name: "Country", search: { value: "", operatorValue: ""} },
    { data: "PostalCode", name: "PostalCode", search: { value: "", operatorValue: ""} },
    { data: "CellPhoneNumber", name: "Cell Phone Number", search: { value: "", operatorValue: ""} },
    { data: "OfficeNumber", name: "Office Number", search: { value: "", operatorValue: ""} },
    { data: "CompliantChannelName", name: "Compliant Channel Name", search: { value: "", operatorValue: ""} },
    { data: "CompliantLocationBranch", name: "Compliant Location Branch", search: { value: "", operatorValue: ""} },
    { data: "ComplaintLocationCity", name: "Complaint Location City", search: { value: "", operatorValue: ""} },
    { data: "EmailAddress", name: "Email Address", search: { value: "", operatorValue: ""} },
    { data: "ComplaintCategoryCode", name: "Complaint Category Code", search: { value: "", operatorValue: ""} },
    { data: "SubjectOfComplaint", name: "Subject Of Complaint", search: { value: "", operatorValue: ""} },
    { data: "ComplaintDescription", name: "Complaint Description", search: { value: "", operatorValue: ""} },
    { data: "DateReceived", name: "Date Received", search: { value: "", operatorValue: "", type: 'date', value2: ''} },
    { data: "DateClosed", name: "Date Closed", search: { value: "", operatorValue: "", type: 'date', value2: ''} },
    { data: "AmountInDispute", name: "Amount In Dispute", search: { value: "", operatorValue: "", type: "number"} },
    { data: "AmountRefunded", name: "Amount Refunded", search: { value: "", operatorValue: "", type: "number"} },
    { data: "AmountRecovered", name: "Amount Recovered", search: { value: "", operatorValue: "", type: "number"} },
    { data: "ActionTaken", name: "Action Taken", search: { value: "", operatorValue: ""} },
    { data: "StatusOfComplaintName", name: "Status Of ComplaintName", search: { value: "", operatorValue: ""} },
    { data: "FiRemarks", name: "Fi Remarks", search: { value: "", operatorValue: ""} },
    { data: "SlaBreached", name: "Sla Breached", search: { value: "", operatorValue: ""} },
    { data: "SubmissionDate", name: "Submission Date", search: { value: "", operatorValue: "", type: 'date', value2: ''} },
    { data: "GenderName", name: "Gender Name", search: { value: "", operatorValue: ""} },
    { data: "AgeOfComplainant", name: "Age Of Complainant", search: { value: "", operatorValue: ""} },
    { data: "CreatedOn", name: "Created On", search: { value: "", operatorValue: "", type: 'date', value2: ''} }
]

export const regulatoryDirectivesColumns = [
    { data: "title", name: "Regulatory Directive Title", search: { value: "", operatorValue: ""} },
    { data: "Institution.Name", name: "Institution Name", search: { value: "", operatorValue: ""} },
    { data: "description", name: "Description", search: { value: "", operatorValue: ""} },
    { data: "CreatedOn", name: "Date", search: { value: "", operatorValue: "", type: 'date', value2: ''} },
    { data: "UpdatedOn", name: "Updated On", search: { value: "", operatorValue: ""} }
]

export const warningColumns = [
    { data: "title", name: "Warning Title", search: { value: "", operatorValue: ""} },
    { data: "Institution.Name", name: "Institution Name", search: { value: "", operatorValue: ""} },
    { data: "description", name: "Description", search: { value: "", operatorValue: ""} },
    { data: "CreatedOn", name: "Date", search: { value: "", operatorValue: "", type: 'date', value2: ''} },
    { data: "UpdatedOn", name: "Updated On", search: { value: "", operatorValue: ""} }
]

export const sanctionColumns = [
    { data: "title", name: "Sanction Title", search: { value: "", operatorValue: ""} },
    { data: "Institution.Name", name: "Institution Name", search: { value: "", operatorValue: ""} },
    { data: "amount", name: "Amount", search: { value: "", operatorValue: "", type: "number"} },
    { data: "isPaid", name: "Is Paid?", search: { value: "", operatorValue: "", optionType: 'boolean', type: "select", field: "code", fieldDisplay: "code", options: [ { code: 'true' }, { code: 'false' } ] } },
    { data: "description", name: "Description", search: { value: "", operatorValue: ""} },
    { data: "CreatedOn", name: "Date", search: { value: "", operatorValue: "", type: 'date', value2: ''} },
    { data: "UpdatedOn", name: "Updated On", search: { value: "", operatorValue: ""} }
]

export const technicalSessionColumns = [
    { data: "title", name: "Session Title", search: { value: "", operatorValue: ""} },
    { data: "Institution.Name", name: "Institution Name", search: { value: "", operatorValue: ""} },
    { data: "description", name: "Description", search: { value: "", operatorValue: ""} },
    { data: "startDate", name: "Start Date", search: { value: "", operatorValue: ""} },
    { data: "endDate", name: "End Date", search: { value: "", operatorValue: ""} },
    { data: "CreatedOn", name: "Date", search: { value: "", operatorValue: "", type: 'date', value2: ''} },
    { data: "UpdatedOn", name: "Updated On", search: { value: "", operatorValue: ""} }
]

export const currencyFormat = Intl.NumberFormat('en-US');


export const getStatusColor = (status) => {
    switch(status) {
        case 'SUBMITTED':
            return 'info'
        case 'PROCESSING':
            return 'warning'
        case 'PROCESSED':
            return 'primary'
        case 'PROCESSED':
            return 'primary'
        case 'PROCESSED':
            return 'primary'
        case 'active':
            return 'primary'
        case 'inactive':
            return 'error'
        default:
            return ''
    }
}

export const testCases = [
    {
        "caseId": "TST530017434",
        "institutionId": 12,
        "workflowId": 8,
        "trackingReferenceNumber": "TST530017434",
        "branchName": "ABUJA",
        "nameOfConsultant": "NA",
        "clientTypeName": "INDV",
        "nameOfComplainant": null,
        "firstName": "DEMAS",
        "middleName": "NA",
        "lastName": "UKUM",
        "uniqueIdentificationNo": "12254401053",
        "accountNumber": "0021432968",
        "accountTypeName": "SAVINGS",
        "currencyCode": "NGN",
        "streetAddressLine1": "BHD UBE GIRI FCT",
        "streetAddressLine2": "NA",
        "city": "ABUJA",
        "state": "FCT",
        "country": "NG",
        "postalCode": "NA",
        "cellPhoneNumber": "(234) 706-2448095",
        "officeNumber": "(234) 706-2448095",
        "compliantChannelName": "OTHERS",
        "compliantLocationBranch": "ABUJA",
        "complaintLocationCity": "ABUJA",
        "emailAddress": "aimuamwosa.edogun@ubagroup.com",
        "complaintCategoryCodeName": "A001",
        "subjectOfComplaint": "FREEZE ACCOUNT DUE TO FRAUDULENT AVTIVITIES",
        "complaintDescription": "Kindly freeze account due to fraudulent activities  card has been blocked  umobile profile has been deleted  Proper KYC done ACCOUNT NAME: DEMAS UKUMACCOUNT NUMBER: 2073983565 REASON:",
        "dateReceived": "2017-02-10T00:00:00",
        "dateClosed": null,
        "amountInDispute": 2000,
        "amountRefunded": 0,
        "amountRecovered": 0,
        "actionTaken": "ACCOUNT CLOSED",
        "statusOfComplaintName": "NEW",
        "statusOfComplaintId": 0,
        "fiRemarks": "OKAY",
        "cbnStatus": "NEW",
        "cbnRemarks": null,
        "slaBreached": true,
        "submissionDate": null,
        "escalationStatus": null,
        "escalationDate": null,
        "escalationBy": null,
        "genderName": "M",
        "ageOfComplainant": 56,
        "ppDocUploadReq": null,
        "ppDocUploadRejReason": null,
        "ppDocUploadReqReason": null,
        "assignedUser": "a18be9c0-aa65-4af8-bd17-00bd9344e575",
        "assignedBy": "a18be9c0-aa65-4af8-bd17-00bd9344e575",
        "ppReasonForEscalation": null,
        "ppReasonForRejection": null,
        "workflowActionableCount": null,
        "institution": null,
        "accountType": null,
        "clientType": null,
        "compliantChannel": null,
        "statusOfComplaint": null,
        "workflow": null,
        "gender": null,
        "currency": null,
        "complaintCategoryCode": null,
        "documents": null,
        "casesHistory": null,
        "workFlowLogs": null,
        "workflowActionables": null,
        "createdBy": "SYSTEM",
        "createdOn": "2022-08-02T09:36:11.651975",
        "updatedBy": "SYSTEM",
        "updatedOn": "2022-09-27T10:48:59.494241",
        "isActive": true,
        "deletedBy": null,
        "status": "UPDATED"
    },
    {
        "caseId": "TST53001743",
        "institutionId": 12,
        "workflowId": 7,
        "trackingReferenceNumber": "TST53001743",
        "branchName": "ABUJA",
        "nameOfConsultant": "NA",
        "clientTypeName": "INDV",
        "nameOfComplainant": null,
        "firstName": "DEMAS",
        "middleName": "NA",
        "lastName": "UKUM",
        "uniqueIdentificationNo": "12254401053",
        "accountNumber": "0021432968",
        "accountTypeName": "SAVINGS",
        "currencyCode": "NGN",
        "streetAddressLine1": "BHD UBE GIRI FCT",
        "streetAddressLine2": "NA",
        "city": "ABUJA",
        "state": "FCT",
        "country": "NG",
        "postalCode": "NA",
        "cellPhoneNumber": "(234) 706-2448095",
        "officeNumber": "(234) 706-2448095",
        "compliantChannelName": "OTHERS",
        "compliantLocationBranch": "ABUJA",
        "complaintLocationCity": "ABUJA",
        "emailAddress": "aimuamwosa.edogun@ubagroup.com",
        "complaintCategoryCodeName": "A001",
        "subjectOfComplaint": "FREEZE ACCOUNT DUE TO FRAUDULENT AVTIVITIES",
        "complaintDescription": "Kindly freeze account due to fraudulent activities  card has been blocked  umobile profile has been deleted  Proper KYC done ACCOUNT NAME: DEMAS UKUMACCOUNT NUMBER: 2073983565 REASON:",
        "dateReceived": "2017-02-10T00:00:00",
        "dateClosed": null,
        "amountInDispute": 2000,
        "amountRefunded": 0,
        "amountRecovered": 0,
        "actionTaken": "ACCOUNT CLOSED",
        "statusOfComplaintName": "NEW",
        "statusOfComplaintId": 0,
        "fiRemarks": "OKAY",
        "cbnStatus": "NEW",
        "cbnRemarks": null,
        "slaBreached": true,
        "submissionDate": null,
        "escalationStatus": null,
        "escalationDate": null,
        "escalationBy": null,
        "genderName": "M",
        "ageOfComplainant": 56,
        "ppDocUploadReq": null,
        "ppDocUploadRejReason": null,
        "ppDocUploadReqReason": null,
        "assignedUser": "UNASSIGNED",
        "assignedBy": "SYSTEM",
        "ppReasonForEscalation": null,
        "ppReasonForRejection": null,
        "workflowActionableCount": null,
        "institution": null,
        "accountType": null,
        "clientType": null,
        "compliantChannel": null,
        "statusOfComplaint": null,
        "workflow": null,
        "gender": null,
        "currency": null,
        "complaintCategoryCode": null,
        "documents": null,
        "casesHistory": null,
        "workFlowLogs": null,
        "workflowActionables": null,
        "createdBy": "SYSTEM",
        "createdOn": "2022-08-02T09:35:47.054642",
        "updatedBy": "SYSTEM",
        "updatedOn": "2022-08-03T20:44:31.757681",
        "isActive": true,
        "deletedBy": null,
        "status": "UPDATED"
    },
    {
        "caseId": "TST53001",
        "institutionId": 12,
        "workflowId": 5,
        "trackingReferenceNumber": "TST53001",
        "branchName": "ABUJA",
        "nameOfConsultant": "NA",
        "clientTypeName": "INDV",
        "nameOfComplainant": null,
        "firstName": "DEMAS",
        "middleName": "NA",
        "lastName": "UKUM",
        "uniqueIdentificationNo": "12254401053",
        "accountNumber": "0021432968",
        "accountTypeName": "SAVINGS",
        "currencyCode": "NGN",
        "streetAddressLine1": "BHD UBE GIRI FCT",
        "streetAddressLine2": "NA",
        "city": "ABUJA",
        "state": "FCT",
        "country": "NG",
        "postalCode": "NA",
        "cellPhoneNumber": "(234) 706-2448095",
        "officeNumber": "(234) 706-2448095",
        "compliantChannelName": "OTHERS",
        "compliantLocationBranch": "ABUJA",
        "complaintLocationCity": "ABUJA",
        "emailAddress": "aimuamwosa.edogun@ubagroup.com",
        "complaintCategoryCodeName": "A001",
        "subjectOfComplaint": "FREEZE ACCOUNT DUE TO FRAUDULENT AVTIVITIES",
        "complaintDescription": "Kindly freeze account due to fraudulent activities  card has been blocked  umobile profile has been deleted  Proper KYC done ACCOUNT NAME: DEMAS UKUMACCOUNT NUMBER: 2073983565 REASON:",
        "dateReceived": "2017-02-10T00:00:00",
        "dateClosed": null,
        "amountInDispute": 2000,
        "amountRefunded": 0,
        "amountRecovered": 0,
        "actionTaken": "ACCOUNT CLOSED",
        "statusOfComplaintName": "NEW",
        "statusOfComplaintId": 0,
        "fiRemarks": "OKAY",
        "cbnStatus": "NEW",
        "cbnRemarks": null,
        "slaBreached": true,
        "submissionDate": null,
        "escalationStatus": null,
        "escalationDate": null,
        "escalationBy": null,
        "genderName": "M",
        "ageOfComplainant": 56,
        "ppDocUploadReq": null,
        "ppDocUploadRejReason": null,
        "ppDocUploadReqReason": null,
        "assignedUser": "UNASSIGNED",
        "assignedBy": "SYSTEM",
        "ppReasonForEscalation": null,
        "ppReasonForRejection": null,
        "workflowActionableCount": null,
        "institution": null,
        "accountType": null,
        "clientType": null,
        "compliantChannel": null,
        "statusOfComplaint": null,
        "workflow": null,
        "gender": null,
        "currency": null,
        "complaintCategoryCode": null,
        "documents": null,
        "casesHistory": null,
        "workFlowLogs": null,
        "workflowActionables": null,
        "createdBy": "SYSTEM",
        "createdOn": "2022-07-27T14:35:33.300588",
        "updatedBy": "SYSTEM",
        "updatedOn": "2022-08-03T20:37:57.273009",
        "isActive": true,
        "deletedBy": null,
        "status": "UPDATED"
    },
    {
        "caseId": "TST530017",
        "institutionId": 12,
        "workflowId": 6,
        "trackingReferenceNumber": "TST530017",
        "branchName": "ABUJA",
        "nameOfConsultant": "NA",
        "clientTypeName": "INDV",
        "nameOfComplainant": null,
        "firstName": "DEMAS",
        "middleName": "NA",
        "lastName": "UKUM",
        "uniqueIdentificationNo": "12254401053",
        "accountNumber": "0021432968",
        "accountTypeName": "SAVINGS",
        "currencyCode": "NGN",
        "streetAddressLine1": "BHD UBE GIRI FCT",
        "streetAddressLine2": "NA",
        "city": "ABUJA",
        "state": "FCT",
        "country": "NG",
        "postalCode": "NA",
        "cellPhoneNumber": "(234) 706-2448095",
        "officeNumber": "(234) 706-2448095",
        "compliantChannelName": "OTHERS",
        "compliantLocationBranch": "ABUJA",
        "complaintLocationCity": "ABUJA",
        "emailAddress": "aimuamwosa.edogun@ubagroup.com",
        "complaintCategoryCodeName": "A001",
        "subjectOfComplaint": "FREEZE ACCOUNT DUE TO FRAUDULENT AVTIVITIES",
        "complaintDescription": "Kindly freeze account due to fraudulent activities  card has been blocked  umobile profile has been deleted  Proper KYC done ACCOUNT NAME: DEMAS UKUMACCOUNT NUMBER: 2073983565 REASON:",
        "dateReceived": "2017-02-10T00:00:00",
        "dateClosed": null,
        "amountInDispute": 2000,
        "amountRefunded": 0,
        "amountRecovered": 0,
        "actionTaken": "ACCOUNT CLOSED",
        "statusOfComplaintName": "ASSIGNED",
        "statusOfComplaintId": 0,
        "fiRemarks": "OKAY",
        "cbnStatus": "NEW",
        "cbnRemarks": null,
        "slaBreached": true,
        "submissionDate": null,
        "escalationStatus": null,
        "escalationDate": null,
        "escalationBy": null,
        "genderName": "M",
        "ageOfComplainant": 56,
        "ppDocUploadReq": null,
        "ppDocUploadRejReason": null,
        "ppDocUploadReqReason": null,
        "assignedUser": "UNASSIGNED",
        "assignedBy": "SYSTEM",
        "ppReasonForEscalation": null,
        "ppReasonForRejection": null,
        "workflowActionableCount": null,
        "institution": null,
        "accountType": null,
        "clientType": null,
        "compliantChannel": null,
        "statusOfComplaint": null,
        "workflow": null,
        "gender": null,
        "currency": null,
        "complaintCategoryCode": null,
        "documents": null,
        "casesHistory": null,
        "workFlowLogs": null,
        "workflowActionables": null,
        "createdBy": "SYSTEM",
        "createdOn": "2022-07-28T12:30:55.650713",
        "updatedBy": "SYSTEM",
        "updatedOn": "2022-08-03T20:37:57.302773",
        "isActive": true,
        "deletedBy": null,
        "status": "UPDATED"
    },
    {
        "caseId": "TST53001743422",
        "institutionId": 12,
        "workflowId": 4,
        "trackingReferenceNumber": "TST53001743422",
        "branchName": "ABUJA",
        "nameOfConsultant": "NA",
        "clientTypeName": "INDV",
        "nameOfComplainant": null,
        "firstName": "DEMAS",
        "middleName": "NA",
        "lastName": "UKUM",
        "uniqueIdentificationNo": "12254401053",
        "accountNumber": "0021432968",
        "accountTypeName": "SAVINGS",
        "currencyCode": "NGN",
        "streetAddressLine1": "BHD UBE GIRI FCT",
        "streetAddressLine2": "NA",
        "city": "ABUJA",
        "state": "FCT",
        "country": "NG",
        "postalCode": "NA",
        "cellPhoneNumber": "(234) 706-2448095",
        "officeNumber": "(234) 706-2448095",
        "compliantChannelName": "OTHERS",
        "compliantLocationBranch": "ABUJA",
        "complaintLocationCity": "ABUJA",
        "emailAddress": "aimuamwosa.edogun@ubagroup.com",
        "complaintCategoryCodeName": "A001",
        "subjectOfComplaint": "FREEZE ACCOUNT DUE TO FRAUDULENT AVTIVITIES",
        "complaintDescription": "Kindly freeze account due to fraudulent activities  card has been blocked  umobile profile has been deleted  Proper KYC done ACCOUNT NAME: DEMAS UKUMACCOUNT NUMBER: 2073983565 REASON:",
        "dateReceived": "2017-02-10T00:00:00",
        "dateClosed": null,
        "amountInDispute": 2000,
        "amountRefunded": 0,
        "amountRecovered": 0,
        "actionTaken": "ACCOUNT CLOSED",
        "statusOfComplaintName": "NEW",
        "statusOfComplaintId": 0,
        "fiRemarks": "OKAY",
        "cbnStatus": "NEW",
        "cbnRemarks": null,
        "slaBreached": true,
        "submissionDate": null,
        "escalationStatus": null,
        "escalationDate": null,
        "escalationBy": null,
        "genderName": "M",
        "ageOfComplainant": 56,
        "ppDocUploadReq": null,
        "ppDocUploadRejReason": null,
        "ppDocUploadReqReason": null,
        "assignedUser": "UNASSIGNED",
        "assignedBy": "SYSTEM",
        "ppReasonForEscalation": null,
        "ppReasonForRejection": null,
        "workflowActionableCount": null,
        "institution": null,
        "accountType": null,
        "clientType": null,
        "compliantChannel": null,
        "statusOfComplaint": null,
        "workflow": null,
        "gender": null,
        "currency": null,
        "complaintCategoryCode": null,
        "documents": null,
        "casesHistory": null,
        "workFlowLogs": null,
        "workflowActionables": null,
        "createdBy": "SYSTEM",
        "createdOn": "2022-08-02T09:36:18.491476",
        "updatedBy": "SYSTEM",
        "updatedOn": "2022-08-02T18:31:55.011351",
        "isActive": true,
        "deletedBy": null,
        "status": "UPDATED"
    }
];

export const testCaseDetails = {
    "caseId": "TST530017434",
    "institutionId": 12,
    "workflowId": 8,
    "trackingReferenceNumber": "TST530017434",
    "branchName": "ABUJA",
    "nameOfConsultant": "NA",
    "clientTypeName": "INDV",
    "nameOfComplainant": null,
    "firstName": "DEMAS",
    "middleName": "NA",
    "lastName": "UKUM",
    "uniqueIdentificationNo": "12254401053",
    "accountNumber": "0021432968",
    "accountTypeName": "SAVINGS",
    "currencyCode": "NGN",
    "streetAddressLine1": "BHD UBE GIRI FCT",
    "streetAddressLine2": "NA",
    "city": "ABUJA",
    "state": "FCT",
    "country": "NG",
    "postalCode": "NA",
    "cellPhoneNumber": "(234) 706-2448095",
    "officeNumber": "(234) 706-2448095",
    "compliantChannelName": "OTHERS",
    "compliantLocationBranch": "ABUJA",
    "complaintLocationCity": "ABUJA",
    "emailAddress": "aimuamwosa.edogun@ubagroup.com",
    "complaintCategoryCodeName": "A001",
    "subjectOfComplaint": "FREEZE ACCOUNT DUE TO FRAUDULENT AVTIVITIES",
    "complaintDescription": "Kindly freeze account due to fraudulent activities  card has been blocked  umobile profile has been deleted  Proper KYC done ACCOUNT NAME: DEMAS UKUMACCOUNT NUMBER: 2073983565 REASON:",
    "dateReceived": "2017-02-10T00:00:00",
    "dateClosed": null,
    "amountInDispute": 2000,
    "amountRefunded": 0,
    "amountRecovered": 0,
    "actionTaken": "ACCOUNT CLOSED",
    "statusOfComplaintName": "NEW",
    "statusOfComplaintId": 0,
    "fiRemarks": "OKAY",
    "cbnStatus": "NEW",
    "cbnRemarks": null,
    "slaBreached": true,
    "submissionDate": null,
    "escalationStatus": null,
    "escalationDate": null,
    "escalationBy": null,
    "genderName": "M",
    "ageOfComplainant": 56,
    "ppDocUploadReq": null,
    "ppDocUploadRejReason": null,
    "ppDocUploadReqReason": null,
    "assignedUser": "a18be9c0-aa65-4af8-bd17-00bd9344e575",
    "assignedBy": "a18be9c0-aa65-4af8-bd17-00bd9344e575",
    "ppReasonForEscalation": null,
    "ppReasonForRejection": null,
    "workflowActionableCount": null,
    "institution": null,
    "accountType": null,
    "clientType": null,
    "compliantChannel": null,
    "statusOfComplaint": null,
    "workflow": null,
    "gender": null,
    "currency": null,
    "complaintCategoryCode": null,
    "documents": null,
    "casesHistory": null,
    "workFlowLogs": null,
    "workflowActionables": null,
    "createdBy": "SYSTEM",
    "createdOn": "2022-08-02T09:36:11.651975",
    "updatedBy": "SYSTEM",
    "updatedOn": "2022-09-27T10:48:59.494241",
    "isActive": true,
    "deletedBy": null,
    "status": "UPDATED",
    actions: [
        {
            senderWorkflowCommunication: {
                subject: 'Request for customer BVN record',
                message: `Kindly attach the customer's BVN so we can continue the investigation for the duplicate transaction`,
                messageDate: '2002-10-10',
                deadlineDate: '2002-10-10'
            }
        },
        {
            senderWorkflowCommunication: {
                subject: 'Request for customer recent electricity bill',
                message: `Kindly attach the customer's electricity bill to confirm contomers home address so we can arrest him`,
                messageDate: '2002-10-10',
                deadlineDate: '2024-10-10'
            }
        },
    ],
    changes: [
        {
            "id": 1,
            "institutionId": 12,
            "caseId": "TST53001743422",
            "workflowId": 4,
            "changes": [
                {
                    "fieldName": "",
                    "oldValue": "",
                    "newValue": ""
                },
                {
                    "fieldName": "StatusOfComplaintName",
                    "oldValue": "NEW",
                    "newValue": "CLOSED"
                }
            ],
            "createdBy": "SYSTEM",
            "createdOn": "2022-10-12T15:00:08.069965",
            "updatedBy": null,
            "updatedOn": null,
            "isActive": true,
            "deletedBy": null,
            "status": "CREATED"
        }
    ]
}

export const testRelationshipOfficers = [
    {
        "id": "a18be9c0-aa65-4af8-bds17-00bd9344e575",
        "phoneNumber": null,
        "employeeId": null,
        "email": "admin@ccms.com",
        "lastName": "Eze",
        "firstName": "Musa",
        "otherNames": "Taiwo",
        "gender": null,
        "team": "a18be9c0-aa65-4af8-bd17-00bd9344e575",
    },
    {
        "id": "a18be9c0-aa65-4af8-bd17-00bd9344e575",
        "phoneNumber": null,
        "employeeId": null,
        "email": "admin@ccms.com",
        "lastName": "Moses",
        "firstName": "Sandra",
        "otherNames": "Chidinma",
        "gender": null,
        "team": "a18be9c0-aa65-4af8-bd17-00bd9344es575",
    }
]

export const testTeams = [
    {
        "id": "a18be9c0-aa65-4af8-bd17-00bd9344e575",
        "team": "Team A",
    },
    {
        "id": "a18be9c0-aa65-4af8-bd17-00bd9344es575",
        "team": "Team B",
    }
]

export const testAnalytics = [
    {
        "statName": "MyOpenCasesStats",
        "statValues": [
            {
                "instName": "ALL",
                "caseCount": 1
            }
        ]
    },
    {
        "statName": "myClosedCasesStats",
        "statValues": [
            {
                "instName": "ALL",
                "caseCount": 0
            }
        ]
    },
    {
        "statName": "myCases",
        "statValues": [
            {
                "instName": "ALL",
                "caseCount": 0
            }
        ]
    },
    {
        "statName": "BreachedCases",
        "statValues": [
            {
                "instName": "FIRST BANK OF NIGERIA PLC",
                "caseCount": 5
            },
            {
                "instName": "ZENITH BANK PLC",
                "caseCount": 5
            },
            {
                "instName": "ECO BANK PLC",
                "caseCount": 5
            }
        ]
    },
    {
        "statName": "OpenCases",
        "statValues": [
            {
                "instName": "UNION BANK PLC",
                "caseCount": 10
            },
            {
                "instName": "ZENITH BANK PLC",
                "caseCount": 5
            },
            {
                "instName": "UNITED BANK OF AFRICA",
                "caseCount": 3
            }
        ]
    },
    {
        "statName": "ClosedCases",
        "statValues": []
    }
]

export const testUpdateHistory = [
    {
        "id": 1,
        "institutionId": 12,
        "caseId": "TST53001743422",
        "workflowId": 4,
        "changes": [
            {
                "fieldName": "StatusOfComplaintName",
                "oldValue": "NEW",
                "newValue": "CLOSED"
            }
        ],
        "createdBy": "SYSTEM",
        "createdOn": "2022-10-12T15:00:08.069965",
        "updatedBy": null,
        "updatedOn": null,
        "isActive": true,
        "deletedBy": null,
        "status": "CREATED"
    },
    {
        "id": 1,
        "institutionId": 12,
        "caseId": "TST53001743422",
        "workflowId": 4,
        "changes": [
            {
                "fieldName": "StatusOfComplaintName",
                "oldValue": "NEW",
                "newValue": "CLOSED"
            }
        ],
        "createdBy": "SYSTEM",
        "createdOn": "2022-10-12T15:00:08.069965",
        "updatedBy": null,
        "updatedOn": null,
        "isActive": true,
        "deletedBy": null,
        "status": "UPDATED"
    },
    {
        "id": 1,
        "institutionId": 12,
        "caseId": "TST53001743422",
        "workflowId": 4,
        "changes": [
            {
                "fieldName": "StatusOfComplaintName",
                "oldValue": "NEW",
                "newValue": "CLOSED"
            }
        ],
        "createdBy": "SYSTEM",
        "createdOn": "2022-10-12T15:00:08.069965",
        "updatedBy": null,
        "updatedOn": null,
        "isActive": true,
        "deletedBy": null,
        "status": "CLOSE"
    },
]

export const testUsers = [
    {
        "id": "a18be9c0-aa65-4af8-bd17-00bd9344e675",
        "phoneNumber": null,
        "employeeId": null,
        "email": "superadmin@ccms.com",
        "userType": null,
        "password": null,
        "confirmPassword": null,
        "lastName": "Tammy",
        "firstName": "Abraham",
        "gender": null,
        "institutionId": 12,
        "createdDate": '2022-10-10',
        "modifiedDate": null,
        "isActive": true,
        "isEmailConfirmed": true,
        "institutionName": "FIRST BANK OF NIGERIA PLC"
    },
    {
        "id": "a18be9c0-aa65-4af8-bd17-00bd9344e575",
        "phoneNumber": null,
        "employeeId": null,
        "email": "admin@ccms.com",
        "userType": "DMB",
        "password": null,
        "confirmPassword": null,
        "lastName": "Lampard",
        "firstName": "Frank",
        "gender": null,
        "institutionId": 12,
        "createdDate": '2022-10-10',
        "modifiedDate": null,
        "isActive": true,
        "isEmailConfirmed": true,
        "institutionName": "FIRST BANK OF NIGERIA PLC"
    }
]

export const getBase64FromFile = (file) => {
    return new Promise((resolve, reject) => {
        try {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                resolve(reader.result);
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
            };
        }
        catch(err) {
            console.log(err);
            reject(err.message)
        }
    })
}


export const openFileInNewBrowser = (file, isUrl = false, type) => {
    const blobUrl = isUrl ? file : URL.createObjectURL(file);

    // window.open('', " form preview", "width=200, height=400", '_blank');

    // window.open(blobUrl, '_blank').location.reload();
    // myWindow.opener.location.reload();

    let base64File = blobUrl?.split(';base64,')?.pop();
    printBase64(base64File, type)

    // var hiddenElement = document.createElement('a');
    // hiddenElement.href = blobUrl;
    // hiddenElement.download = 'exportar.'+'pdf';
    // hiddenElement.click();

}

export const printBase64 = (base64URL, type = 'pdf', header = '') => {
    console.log(type)
    printJS({ printable: base64URL, type, base64: true, header })
}

export const getBase64Type = (fileName) => {
    const ext = String(fileName).split('.')[String(fileName).split('.').length - 1];
    switch(ext) {
        case 'xlsx':
            return 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,';
        case 'csv':
            return 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,';
        case 'pdf':
            return 'data:application/pdf;base64,';
        case 'jpeg':
            return 'data:image/png;base64,';
        case 'png':
            return 'data:image/png;base64,';
        case 'jpeg':
            return 'data:image/png;base64,';
        default:
            return '';
    }
}

export const openBase64 = (base64, type, fileName) => {
    const ext = String(type).split('/')[String(type).split('/').length - 1];

    var hiddenElement = document.createElement('a');
    hiddenElement.href = getBase64Type(ext) + base64;
    hiddenElement.download = `${fileName}`;
    hiddenElement.click();
}

export const getPrivilegeStatus = (privilege = '') => {
    const user = store?.getState()?.user?.userData || {}
    const privileges = user?.rolePermissions?.map(({ permissionName }) => permissionName) || []
    if(typeof(privilege) === 'string') {
        return Boolean(privileges.find(permissionName => privilege === permissionName)) ? true : false
    } else {
        return Boolean( privilege.map((priv) => Boolean(privileges.find(permissionName => priv === permissionName))).reduce((prev, nex) => prev || nex)) ? true : false
    }
}

const testWork = {}